export default "__VITE_ASSET__CzjumRV1__"